import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, color = "#637381" } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 12.9177C9.80558 12.9181 9.61688 12.8503 9.46696 12.726L4.46696 8.55938C4.11257 8.26482 4.06407 7.73876 4.35862 7.38438C4.65317 7.02999 5.17924 6.98149 5.53362 7.27604L10.0003 11.0094L14.467 7.40938C14.6391 7.26957 14.8599 7.20415 15.0804 7.22761C15.301 7.25107 15.5031 7.36148 15.642 7.53438C15.7962 7.70759 15.8713 7.93727 15.8492 8.16817C15.8271 8.39908 15.7097 8.6103 15.5253 8.75104L10.5253 12.776C10.3711 12.8806 10.1862 12.9305 10.0003 12.9177Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
